import { db } from "../../lib/init-firebase";
import { collection, getDocs } from "firebase/firestore";

const get24hVolume = async () => {
  try {
    // Get the query snapshot of the "data" collection
    try {
      const querySnapshot = await getDocs(collection(db, "data"));

      // Define the result object
      const result = {
        totalSells: 0,
        totalBuys: 0,
        totalAmount: 0,
        numberOfTransactions: 0,
        sortedLeaderboardSells: [],
        sortedLeaderboardBuys: [],
        network: 1,
      };

      querySnapshot.forEach((doc) => {
        const data = doc.data();

        const totalSells = data.totalSells;
        const totalBuys = data.totalBuys;
        const totalAmount = data.totalAmount;
        const numberOfTransactions = data.numberOfTransactions;

        result.totalSells += totalSells;
        result.totalBuys += totalBuys;
        result.totalAmount += totalAmount;
        result.numberOfTransactions += numberOfTransactions;

        const leaderboardSells = Object.entries(
          data.sortedLeaderboardSells
        ).map(([address, amount]) => {
          return { address, amount: parseFloat(amount) };
        });

        const leaderboardBuys = Object.entries(data.sortedLeaderboardBuys).map(
          ([address, amount]) => {
            return { address, amount: parseFloat(amount) };
          }
        );

        result.sortedLeaderboardSells.push(...leaderboardSells);
        result.sortedLeaderboardBuys.push(...leaderboardBuys);
      });

      result.sortedLeaderboardSells.sort((a, b) => b.amount - a.amount);

      result.sortedLeaderboardBuys.sort((a, b) => b.amount - a.amount);

      return result;
    } catch (error) {
      const result = {
        network: 0,
      };
      return result;
    }
  } catch (error) {
    console.error("Error retrieving data:", error);
    return null;
  }
};

export default get24hVolume;
